import './sendToSupplierFileDropArea.scss';

import { globalEventService } from '@approvalmax/utils';
import { DragNDropIcon, SendFilesToSupplierIcon } from 'modules/sprites';
import { FC, memo, useEffect, useRef, useState } from 'react';
import bemFactory from 'react-bem-factory';

import { AttachmentKind } from '../data/AttachmentKind';
import FileDropProvider from './FileDropProvider';
import { messages } from './SendToSupplierFileDropArea.messages';

const bem = bemFactory.block('reqf-send-to-supplier-file-drop-area');
const qa = bemFactory.qa('reqf-send-to-supplier-file-drop-area');

interface SendToSupplierFileDropAreaProps {
    className?: string;
    isSupplierAreaActive?: boolean;
}

const SendToSupplierFileDropArea: FC<SendToSupplierFileDropAreaProps> = (props) => {
    const { className, isSupplierAreaActive } = props;

    const [isActive, setIsActive] = useState(false);

    let counterRef = useRef<number>(0);

    useEffect(() => {
        function onDragEnter() {
            if (counterRef.current === 0) {
                setIsActive(true);
            }

            counterRef.current++;
        }

        function onDragLeave() {
            counterRef.current--;

            if (counterRef.current === 0) {
                setIsActive(false);
            }
        }

        function onDrop() {
            counterRef.current = 0;
            setIsActive(false);
        }

        globalEventService.on('window:dragenter:captured', onDragEnter);
        globalEventService.on('window:dragleave:captured', onDragLeave);
        globalEventService.on('window:drop:captured', onDrop);

        return function cleanup() {
            globalEventService.off('window:dragenter:captured', onDragEnter);
            globalEventService.off('window:dragleave:captured', onDragLeave);
            globalEventService.off('window:drop:captured', onDrop);
        };
    }, [counterRef, setIsActive]);

    return (
        <FileDropProvider.Consumer>
            {({ setAttachmentKind, attachmentKind }) => (
                <div data-qa={qa()} className={bem.add(className)(null, { active: isActive })}>
                    <div
                        className={bem.add(className)('common-area', {
                            active: isActive && attachmentKind === AttachmentKind.General,
                        })}
                        onDragEnter={() => {
                            setAttachmentKind(AttachmentKind.General);
                        }}
                    >
                        <DragNDropIcon className={bem('drag-n-drop-icon')} width={78} height={74} />

                        <div className={bem('area-text')}>{messages.dropHereText}</div>
                    </div>

                    {isSupplierAreaActive && (
                        <div
                            className={bem.add(className)('supplier-area', {
                                active: isActive && attachmentKind === AttachmentKind.EmailToSupplierAttachment,
                            })}
                            onDragEnter={() => {
                                setAttachmentKind(AttachmentKind.EmailToSupplierAttachment);
                            }}
                            onDragLeave={() => {
                                setAttachmentKind(AttachmentKind.General);
                            }}
                        >
                            <SendFilesToSupplierIcon
                                className={bem('send-files-to-supplier-icon')}
                                width={78}
                                height={74}
                            />

                            <div className={bem('area-text')}>{messages.dropHereSupplierText}</div>
                        </div>
                    )}
                </div>
            )}
        </FileDropProvider.Consumer>
    );
};

export default memo(SendToSupplierFileDropArea);
